import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ContactPopup from "../../components/ContactPopup";
import PdfPopup from "../../components/PdfPopup";
import {
  BannerSection,
  MediaSection,
  EnergySection,
  MentorSection,
  MojoSection,
  OutcomesSection,
  PodcastSliderSection,
  ResultsSection,
} from "../../components/home";
import homeData from "../../data/homeData.json";

const Home = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activePdf, setActivePdf] = useState(null);
  const openContact = () => setIsPopupOpen(true);
  return (
    <>
      <BannerSection data={homeData.banner} onOpenPdf={setActivePdf} />
      {/* <MotivationSection data={homeData.motivation} /> */}
      {/* <ClientLogosSection data={homeData.clients} /> */}
      <MentorSection data={homeData.mentor} onOpenContact={openContact} />
      <MediaSection data={homeData.media} />
      <EnergySection data={homeData.student} onOpenContact={openContact} />
      <PodcastSliderSection data={homeData.podcastSlider} />
      
      <ResultsSection data={homeData.results} />
      <OutcomesSection data={homeData.outcomes} onOpenContact={openContact} />
      <MojoSection data={homeData.mojo} />
      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
      <PdfPopup
        isOpen={Boolean(activePdf)}
        onClose={() => setActivePdf(null)}
        pdfUrl={activePdf?.pdf}
        pages={activePdf?.pages}
        title={activePdf?.title || "Catalyze Magazine"}
      />
    </>
  );
};

export default Home;
